import {
  Select,
  TextField
} from '@mui/material';
import { Button } from 'component/MarketPlace/ButtonComponents';
import Box from 'component/layoutComponents/Box/Box';
import DefaultUptimeTheme from 'component/theme/defaultTheme';
import styled from 'styled-components';
import { styled as muiStyled } from '@mui/material';

const INPUT_HEIGHT = 40;

export const StyledSortView = styled(Box)(({ theme }) => `
  display: flex;
  gap: ${theme.uptimeSpace[8]}px;
`);

export const StyledTextField = styled(TextField)(({ theme }) => `
  .MuiInputBase-root {
    height: ${INPUT_HEIGHT}px;
  }
  .MuiInputBase-input {
    padding: 8.5px ${theme.uptimeSpace[7]}px;
  }
  .MuiFormLabel-root:not(.Mui-focused) {
    top: -${theme.uptimeSpace[4]}px;
  }
`);

export const StyledSelect = muiStyled(Select)<{ hideLabel?: boolean }>(({ hideLabel }) => ({
  height: `${INPUT_HEIGHT}px`,
  '.MuiSelect-root': {
    padding: `10px 14px`
  },
  '.MuiSelect-select': {
    padding: `8.5px 14px`,
  },
  'legend': {
    width: `${hideLabel ? 0 : 'auto'}`
  },
}));

export const StyledViewButton = styled(Button)<{theme: typeof DefaultUptimeTheme; $active: boolean, $clicked: boolean }>(({ theme, $active, $clicked }) => `
  &.MuiButtonGroup-grouped {
    width: 40px;
    height: ${INPUT_HEIGHT}px;
    padding: 0;
    color: ${theme.uptimeColors.textColors.secondary};
    background-color: ${$active ? `${theme.uptimeColors.grayScales.gray}` : 'transparent'};
    border: 1px solid ${$clicked ? theme.uptimeColors.mainTheme.secondary : theme.uptimeColors.grayScales.gray};
    &:hover {
      background-color: ${theme.uptimeColors.grayScales.gray};
    };
    :not(:last-of-type) {
      border-radius: ${theme.uptimeSpace[2]}px ${theme.uptimeSpace[0]} ${theme.uptimeSpace[0]} ${theme.uptimeSpace[2]}px !important;
    };
    :not(:first-of-type) {
      border-radius: ${theme.uptimeSpace[0]} ${theme.uptimeSpace[2]}px ${theme.uptimeSpace[2]}px ${theme.uptimeSpace[0]} !important;
    };
  }
`);